// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #1c2026;
  color: white;
  padding: 40px 0; /* Reduced height */
  font-family: Arial, sans-serif;
}

.footerCol {
  margin-bottom: 15px;
}

.footerColTitle {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.footerList {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footerItemLink {
  color: #a7b5b7;
  text-decoration: none;
  font-size: 0.9rem;
  line-height: 1.8;
  transition: color 0.3s ease;
}

.footerItemLink:hover {
  color: #fff000;
}

.footerLogo {
  width: 130px;
  height: auto;
  transition: transform 0.3s ease;
}

.footerLogo:hover {
  transform: scale(1.05);
}

/* Align social icons in one row neatly */
.socialIcons {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.socialIconLink {
  color: #fff000;
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.socialIconLink:hover {
  transform: scale(1.15);
  color: #ffffff;
}

/* Copyright Section */
.copyright {
  text-align: center;
  background-color: #0f1115;
  padding: 10px 0;
}

.copyright p {
  margin: 0;
  font-size: 0.75rem;
  color: #a7b5b7;
}

.copyrightItemLink {
  color: #fff000;
  text-decoration: none;
}

.copyrightItemLink:hover {
  color: white;
}

/* Responsive Adjustments */
@media (max-width: 992px) {
  .footer {
    text-align: center;
  }
  .socialIcons {
    justify-content: center;
    margin-top: 10px;
  }
  .footerLogo {
    width: 110px;
  }
}
.footerItem {
  margin-bottom: 10px;
  color: #a7b5b7;
}
.footerItem.addressText {
  color: #a7b5b7;
  font-size: 0.8rem;
  line-height: 1.8;
  font-family: inherit;
  margin-top: 4px;
  transition: color 0.3s ease;
}

.footerItem.addressText:hover {
  color: #fff000;
}`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FOOTER/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe,EAAE,mBAAmB;EACpC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".footer {\n  background-color: #1c2026;\n  color: white;\n  padding: 40px 0; /* Reduced height */\n  font-family: Arial, sans-serif;\n}\n\n.footerCol {\n  margin-bottom: 15px;\n}\n\n.footerColTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.footerList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footerItemLink {\n  color: #a7b5b7;\n  text-decoration: none;\n  font-size: 0.9rem;\n  line-height: 1.8;\n  transition: color 0.3s ease;\n}\n\n.footerItemLink:hover {\n  color: #fff000;\n}\n\n.footerLogo {\n  width: 130px;\n  height: auto;\n  transition: transform 0.3s ease;\n}\n\n.footerLogo:hover {\n  transform: scale(1.05);\n}\n\n/* Align social icons in one row neatly */\n.socialIcons {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-end;\n}\n\n.socialIconLink {\n  color: #fff000;\n  font-size: 1.2rem;\n  transition: transform 0.3s ease;\n}\n\n.socialIconLink:hover {\n  transform: scale(1.15);\n  color: #ffffff;\n}\n\n/* Copyright Section */\n.copyright {\n  text-align: center;\n  background-color: #0f1115;\n  padding: 10px 0;\n}\n\n.copyright p {\n  margin: 0;\n  font-size: 0.75rem;\n  color: #a7b5b7;\n}\n\n.copyrightItemLink {\n  color: #fff000;\n  text-decoration: none;\n}\n\n.copyrightItemLink:hover {\n  color: white;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 992px) {\n  .footer {\n    text-align: center;\n  }\n  .socialIcons {\n    justify-content: center;\n    margin-top: 10px;\n  }\n  .footerLogo {\n    width: 110px;\n  }\n}\n.footerItem {\n  margin-bottom: 10px;\n  color: #a7b5b7;\n}\n.footerItem.addressText {\n  color: #a7b5b7;\n  font-size: 0.8rem;\n  line-height: 1.8;\n  font-family: inherit;\n  margin-top: 4px;\n  transition: color 0.3s ease;\n}\n\n.footerItem.addressText:hover {\n  color: #fff000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
